import { api } from '@utils/api/api'
import { ChatbotConversation, ChatbotFeedbackStatus } from '@interfaces'

const CHATBOT_URL = 'api/v1/ultrai'

export const getThreadId = (): Promise<{ id: string }> =>
  api.post(`${CHATBOT_URL}/threads`)

export const sendRequest = async (
  threadId: string,
  text: string,
  signal?: AbortSignal,
): Promise<ChatbotConversation> => {
  return api.post(
    `${CHATBOT_URL}/chat`,
    {
      threadId,
      text,
    },
    false,
    signal ? { signal } : undefined,
  )
}

export const sendFeedback = (
  threadId: string,
  messageId: string,
  status: ChatbotFeedbackStatus,
): Promise<void> =>
  api.patch(
    `${CHATBOT_URL}/threads/${threadId}/messages/${messageId}/feedback`,
    {
      status,
    },
  )

export const acceptDisclaimer = (): Promise<boolean> =>
  api.post(`${CHATBOT_URL}/terms-and-conditions`)

export const getDisclaimer = (customerId: string): Promise<boolean> =>
  api.get(`${CHATBOT_URL}/terms-and-conditions/${customerId}`)
